import { memo, useEffect } from "react";
import { connect } from "react-redux";
import { clienteController, ClienteViewProps, mapDispatchToClienteProps, mapStateToClienteProps } from "../cliente.controll";
import { Autocomplete, Box, IconButton, Stack, TextField, Typography } from "@mui/material";
import { Cliente } from "../cliente.model";
import { ArrowDropDown, Search } from "@mui/icons-material";
import { ClearIcon } from "@mui/x-date-pickers";
import Modal from "../../../components/modal";
import { columnsCliente } from "./cliente.list.mui";
import { Select as ViewList } from "../../../components/select";
import { ClienteCadastro } from "./cliente.cad";
import store from "../../../store";


interface ClienteAutoCompletProps extends ClienteViewProps {
    handleSelectCliente: (row: Cliente) => any
}


function ClienteAutoComplete(props: ClienteAutoCompletProps) {
    const { clienteActions, clienteState, handleSelectCliente } = props
    const { rows } = clienteState
    useEffect(() => {
        console.log("chamou ClienteAutoComplete")
        if (rows.length === 0) {
            clienteActions.read();
        }
    }, [])

    const handleSelect = (row: Cliente) => {
        console.log("selecionou cliente " + row)
        handleSelectCliente(row)
    }

    return (
        <Autocomplete
            fullWidth
            options={rows}
            autoHighlight
            getOptionLabel={(cliente) => cliente.nome}
            getOptionKey={(cliente) => cliente._id}
            title="Selecionar Cliente"
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            disableClearable
            //popupIcon={<Search fontSize="small"  titleAccess="Selecionar Cliente"/>}
            clearIcon={<ClearIcon fontSize="small" titleAccess="Remover" />}
            renderOption={((props, cliente) => {
                const { key, ...optionProps } = props
                return (
                    <Box
                        key={key}
                        component={"li"}
                        {...optionProps}
                    >
                        <Stack flexDirection={"column"}>
                            <Typography variant="body1">{cliente.nome}</Typography>
                            <Typography variant="caption">{cliente.whatsapp}</Typography>
                        </Stack>
                    </Box>
                )
            })}
            renderInput={(params) =>
                <TextField
                    {...params}
                    label="Selecionar Cliente"
                    slotProps={{
                        htmlInput: {
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                        },
                    }}
                />
            }
            onChange={(ev, cliente) => {
                ev.preventDefault();
                if (cliente)
                    handleSelect(cliente);
            }}
        />
    )
}
interface SelecionarClienteProps extends ClienteViewProps {
    handleConfirmar: (cliente: Cliente) => any;
}

const SelecionarCliente = memo((props: SelecionarClienteProps) => {
    const { clienteActions, clienteState, handleConfirmar } = props
    const { error, loading, msg, row, rows, showAlert, status, showCadModal, changeList, showSelectModal } = clienteState
    const { read, setShowAlert, setClearValue, setShowCadModal, setShowSelectModal } = clienteActions

    useEffect(() => {
        console.log("chamou Selecionar Cliente")
        if (showSelectModal && rows.length === 0) {
            clienteActions.read();
        }
    }, [])

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    function Cadastro() {
        return ClienteCadastro({
            ...props,
            handleCloseView: () => setShowCadModal(false)
        }).renderModal({
            handleClose: () => setShowCadModal(false),
            show: showCadModal,
            heigth: "auto",
        })
    }

    const handleSelecionar = (cliente:Cliente) => {
        handleConfirmar(cliente);
        setShowSelectModal(false);
    }

    const List = () => {
        return (
            <>
                <ViewList
                    displayWidth={window.innerWidth}
                    title={"Selecionar Cliente"}
                    row={row}
                    showAlert={showAlert}
                    closeAlert={() => setShowAlert(false)}
                    msg={msg}
                    status={status}
                    elevation={1}
                    getRowId={(row: Cliente) => row._id}
                    handleOnChange={handleSelecionar}
                    actionsOnkeyEnter={handleSelecionar}
                    showSearchContainer={true}
                    fontSize={20}
                    setTextSearch={() => { }}
                    textSearch={""}
                    multFieldSearch
                    fieldSearch={["nome","whatsapp"]}
                    placeholderTextSearch="Buscar nome ou whatsapp"
                    variantToobar="dense" 
                    columns={columnsCliente}
                    rows={rows}
                    loading={loading}
                    setRow={handleSelecionar}
                    changeList={changeList}
                    buttonNew={{
                        show: true,
                        onClick: handleNovo
                    }}
                    buttonRefresh={{
                        show: true,
                        onClick: () => read()
                    }}
                    ListItemTextPrimary={(row: Cliente) => <Typography component={"span"}>{row.nome} {row.sobrenome}</Typography>}
                    ListItemTextSecondary={(row: Cliente) =>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography component={"span"}>{row.apelido} {row.whatsapp}</Typography>
                            {row.enderecos.length > 0 && (
                                <Typography component={"span"}>{row.enderecos[row.idx_endereco_main].rua}</Typography>
                            )}

                        </Box>
                    }
                />
                <Cadastro />
            </>
        )
    }

    return (
        <Modal
            component={<List />}
            handleClose={() => setShowSelectModal(false)}
            open={showSelectModal}
            heigth="auto"
            width="md"
            handleOnKeyDown={() => { }}
        />
    )
},(prev,next)=>{
    return prev.clienteState.showSelectModal === next.clienteState.showSelectModal
     && prev.clienteState.changeList === next.clienteState.changeList
})

export default connect(mapStateToClienteProps, mapDispatchToClienteProps)(ClienteAutoComplete)
export const ViewSelecionarCliente = connect(mapStateToClienteProps, mapDispatchToClienteProps)(SelecionarCliente)

export const handleShowSelecionarCliente = (set:boolean) => {
    store.dispatch(clienteController.reducer.actions.setShowSelectModal(set));
}

